import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import lazyLoad from '@helper/lazy-load'
import { loadRoutes } from '@helper'
// import appLoader from './loader/app-loader'

const routes = loadRoutes()

const router = createBrowserRouter([
    {
        id: 'root',
        path: '/',
        element: lazyLoad(() => import('@framework/layout/app-root')),
        errorElement: lazyLoad(() => import('@components/error-boundary')),
        children: [
            {
                index: true,
                element: <Navigate to="/app" />
            },
            {
                path: '/login',
                element: lazyLoad(() => import('@pages/login/components/main'))
            },
            {
                path: '/app',
                // loader: appLoader,
                element: lazyLoad(() => import('@framework/layout/app-layout')),
                errorElement: lazyLoad(() => import('@components/error-boundary')),
                children: [...routes]
            },
            {
                path: '/not-found',
                element: lazyLoad(() => import('@pages/not-found/components/main'))
            },
            {
                path: '/gate/*',
                element: lazyLoad(() => import('@pages/gate/components/main'))
            },
            {
                path: '*',
                element: <Navigate to="/app" />
            }
        ]
    }
])

if (import.meta.hot) {
    import.meta.hot.dispose(() => router.dispose())
}

export default () => router
